/**
 * Created by chenzheyu on 2017/6/21.
 */
/**
 * Created by chenzheyu on 2017/6/12.
 */
import XKdatePickerMod from './src/datePickerMod.vue'

XKdatePickerMod.install = function (Vue) {
  Vue.component(XKdatePickerMod.name, XKdatePickerMod)
}

export default XKdatePickerMod



// WEBPACK FOOTER //
// ./src/components/module/datePickerMod/index.js